import { CreateAlertReadEventRequest } from "./CreateAlertReadEventRequest";
import { UserReadAlerts } from "./UserReadAlerts";
import { UserReadAlertsResponse } from "./UserReadAlertsResponse";
import { AlertTypeMapper } from "./AlertTypeMapper";

export class UserReadAlertMapper {
  private alertTypeMapper = new AlertTypeMapper();

  toUserReadAlerts(response: UserReadAlertsResponse): UserReadAlerts {
    return {
      id: response.id,
      readAlertIds: response.readAlertIds,
      alertType: this.alertTypeMapper.toEnum(response.alertType),
      dateCreated: new Date(response.dateCreated),
      dateModified: new Date(response.dateModified),
    };
  }

  toCreateAlertReadEventRequest(
    userReadAlerts: UserReadAlerts
  ): CreateAlertReadEventRequest {
    return {
      readAlertIds: userReadAlerts.readAlertIds,
      alertType: this.alertTypeMapper.toContract(userReadAlerts.alertType),
    };
  }
}
